import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const Header = () => {
    return (
        <div className='  text-center py-48'>
            <h1 className='text-3xl font-bold my-2'>I'm Sajol Bhadra</h1>
            <h1 className='text-2xl'>Full-Stack Web Developer</h1>
            <a href="https://www.linkedin.com/in/sajolbhadra/"><i className="fab fa-linkedin-in px-2 text-3xl "></i></a>
            <a href="https://github.com/sajolbhadra"><i className="fab fa-github my-2 px-2 text-3xl"></i></a>
            <a href="https://www.facebook.com/sajolbhadra13"><i className="fab fa-facebook my-2 px-2 text-3xl"></i></a> <br />
            <a href="https://drive.google.com/file/d/1pGcgZl01sSixcBy0luORCxS7Ai9jVvmc/view?usp=sharing" target="_blank" className='my-2 btn btn-secondary'>View Resume</a>
        </div>
    );
};

export default Header;